import { memo } from 'react';
import { string } from 'prop-types';

import styles from './PersonDetailsList.scss';

const PersonDetailsList = memo(({ name, phone, email, ...props }) => (
  <dl className={styles.PersonDetailsList} {...props}>
    <dt className={styles.Title} data-testid="PersonFullNameTitle">
      Your name
    </dt>
    <dd className={styles.Value} data-testid="PersonFullNameValue">
      {name}
    </dd>

    <dt className={styles.Title} data-testid="PersonPhoneTitle">
      Phone number
    </dt>
    <dd className={styles.Value} data-testid="PersonPhoneValue">
      {phone}
    </dd>

    <dt className={styles.Title} data-testid="PersonEmailTitle">
      Email
    </dt>
    <dd className={styles.Value} data-testid="PersonEmailValue">
      {email}
    </dd>
  </dl>
));

const MemoizedPersonDetailsList = memo(PersonDetailsList);

export { MemoizedPersonDetailsList as PersonDetailsList };

PersonDetailsList.propTypes = {
  name: string.isRequired,
  phone: string.isRequired,
  email: string.isRequired,
};
